G.Timer = function(x,y,font,fontSize,maxWidth,anchorX,anchorY) {
	
	G.OneLineText.call(this,x,y,font,'???',fontSize,maxWidth,anchorX,anchorY);

	this.secLeft = 0;
	this.active = false;

	this.timerBinding = G.sb("onWallClockTimeUpdate").add(this.updateTimer,this);

	this.events.onDestroy.add(function() {
		this.timerBinding.detach();
	},this);

}

G.Timer.prototype = Object.create(G.OneLineText.prototype);


G.Timer.prototype.updateTimer = function() {

	if (!this.active) return;

	G.sfx.clock_tick.play();

	this.secLeft = Math.max(0,this.secLeft-1);
	this.setText(G.changeSecToTimerFormat(this.secLeft));

};

G.Timer.prototype.setSecLeft = function(secLeft) {

	this.secLeft = secLeft;
	this.setText(G.changeSecToTimerFormat(this.secLeft));

};

G.Timer.prototype.start = function(secLeft) {

	this.active = true;

};
